import styled from 'styled-components';

export const RightsTablesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
